import { ActionIcon } from "@mantine/core";
import FlagRounded from "@mui/icons-material/FlagRounded";
import { updateTestQuestionState } from "../../../../../../../../../features/activeTestSessions/activeTestSessionsSlice";
import { useCustomDispatch } from "../../../../../../../../../lib/redux/hooks";

export default function QuestionFlagButton({
  testId,
  questionDocumentId,
  isFlagged,
}: {
  testId: string;
  questionDocumentId: string;
  isFlagged?: boolean;
}) {
  const dispatch = useCustomDispatch();
  return (
    <ActionIcon
      variant={isFlagged ? "light" : "transparent"}
      color={isFlagged ? "red" : "gray"}
      onClick={() => {
        dispatch(
          updateTestQuestionState({
            testId,
            questionId: questionDocumentId,
            questionState: {
              isFlagged: isFlagged ? false : true,
            },
          })
        );
      }}
    >
      <FlagRounded />
    </ActionIcon>
  );
}
